import { NgClass, TitleCasePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment.local';

import { SharingProvider } from '../ts-share-activity.component';

@Component({
  imports: [NgClass, TitleCasePipe],
  selector: 'tl-share-platform-item',
  standalone: true,
  styleUrls: ['./tl-share-platform-item.component.scss'],
  template: ` <div class="sharing-item" (click)="share(platform)">
    <span
      [ngClass]="isShared ? 'shared-icon' : 'hide'"
      class="icon icon-uniE92E"></span>
    <img [src]="platform.icon" [alt]="platform.name + 'icon'" />
    {{ platform.name | titlecase }}
    <div>
      <div #shared id="shared" [ngClass]="isShared ? 'shared-text' : 'hide'">
        partagé !
      </div>
    </div>
  </div>`,
})
export class TrainingLogSharePlatformItemComponent {
  @ViewChild('shared') sharedRef: ElementRef;
  @Input() activityId: number;
  @Input() platform: SharingProvider;
  @Input() sessionId: number;

  isShared = false;
  platforms: string[] = [
    'trainingpeaks',
    'strava',
    'runkeeper',
    'email',
    'decathlon',
    'nolio',
    'runtastic',
    'logbookconcept2',
  ];

  constructor(private http: HttpClient) {}

  share(item: SharingProvider) {
    // if item.link is undefined make sharing by api
    if (item.link) {
      window.open(item.link, '_blank');
    } else {
      const providerName = item.name.toLowerCase().replace(/[ -]/g, '');

      // si l'item.name est une platforms
      if (this.platforms.includes(providerName)) {
        const url: string = environment.api.trainingLog.shareActivity
          .replace('{activityId}', this.activityId.toString())
          .replace('{sessionId}', this.sessionId.toString());
        this.http.post(url, { 'platforms[]': [item.name] }).subscribe({
          error: (err) => {
            console.error(err);
          },
          next: (data) => {
            this.isShared = true; // on affiche le résultat
          },
        });
      } else {
        console.warn(`${item.name} not found`);
      }
    }
  }
}
